import { IQueryOptions, IExecutionOptions } from '../models/query';
import { TranslationHelper } from '../helpers/TranslationHelper';
import { IQueryOptionsCollectionBase } from '../models/query/options/IQueryOptionsCollectionBase';
import { BaseEntityQuery } from './BaseEntityQuery';

export abstract class BaseCollectionQuery<TChildOptions extends IQueryOptionsCollectionBase> extends BaseEntityQuery<TChildOptions> {
	constructor(queryOptions: IQueryOptions, translationHelper?: TranslationHelper) {
		super(queryOptions, translationHelper);
	}
	getItem(executionOptions: IExecutionOptions, collection: any[]) {
		const { culture } = executionOptions;
		const { sort, startIndex = 0, endIndex, index } = this.options;
		let sortedCollection = this.applySort(collection, sort, culture);
		sortedCollection = sortedCollection.slice(startIndex, endIndex);
		if (sortedCollection && sortedCollection.length > 0) {
			if (typeof index === 'number') {
				const targetIndex = this.getIndex(index, sortedCollection);
				if (targetIndex > -1) {
					const item = sortedCollection[targetIndex];
					return item;
				}
			}
			else {
				return sortedCollection;
			}
		}
		return;
	}
	getIndex(targetIndex: number, collection: any[]): number {
		let response = -1;
		if (collection && collection.length > 0 && Math.abs(targetIndex) < collection.length) {
			if (targetIndex >= 0) {
				response = targetIndex;
			}
			else {
				// If the target index is negative take from the back of the array
				response = collection.length + targetIndex;
			}
		}
		return response;
	}
}